import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from 'src/service/language-management.service';
import { BusinessEnabledOption, FocusInputType, KeyValues15, KeyValues5, KeyValues5Sets, KeyValueSet, LocalService, LookupType, NumericConfig, ProductEntryType, ProductInitialization, Status, TriggeredEvent } from 'src/service/local.service';
import { ProductManagementService } from 'src/service/product-management.service';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrl: './product-details.component.scss'
})
export class ProductDetailsComponent {
  @ViewChild('content_product_details')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  lstSectionConfigKeys: string[] = ["product_config"];
  @Input() productId: string = ''; @Input() businessId: string = ''; @Input() RegionalLanguageId: string = ''; @Input() isInventoryEnabled: boolean = false; @Input() selectedProductEntryType: string = ProductEntryType.Billing.toString();
  mandatoryLanguages = []; productInitializationWrapper: ProductInitialization; @Input() isNotConsiderTax: boolean = true; @Input() businessTaxes: KeyValues5Sets[]; @Input() businessTaxCategories: KeyValues5[] = [];
  isSerialNumberAllowed = false; isGroupParentProductInReceipt = true; isTaxFree = false; isPrintTax = false; isShowLanguage = false; isOpenLookup = false; selectedLookupType: LookupType; selectedLookupValue: string = '';
  searchKeyLookup: string = ''; isExcludePrice: boolean = false; @Input() customFields: KeyValues5[] = [];
  @Input() productLabels: KeyValueSet[] = [];


  message: string = ''; isRedAlert: boolean = true; sideBarBodyHeight: number = 10;

  tabs: KeyValueSet[]; selectedTabKey = '1';

  elementIds: any = {
    measurement_type: 'product_config_measurement_type',
    price: 'product_config_price',
    quick_pick: 'quick_pick',
    add_stock: 'txt_add_stock',
    txt_first_price: 'txt_1_1',
    bar_code: 'txt_bar_code',
    product_name: 'txt_product_name',
    product_category: 'txt_product_category',
    product_about: 'txt_product_about',
    product_notes: 'txt_product_notes',
    save_product: 'btn_save_product',
    hsn_code: 'txt_hsn_code',
    sac_code: 'txt_sac_code',
    qty_alert: 'txt_qty_alert',
    print_templates: 'product_config_print_templates',
    txt_custom_field: 'txt_custom_field',
    product_label: 'dd_product_label',
    par_pin: 'txt_par_pin'
  };
  numericConfig: NumericConfig = { isDecimalAllowed: true, isNegativeAllowed: true } as NumericConfig;
  numericConfig1: NumericConfig = { isDecimalAllowed: false, isNegativeAllowed: false } as NumericConfig;

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private languageManagementService: LanguageManagementService, private productManagementService: ProductManagementService) {
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    if (this.RegionalLanguageId != '')
      this.mandatoryLanguages.push(this.RegionalLanguageId);
    else
      this.mandatoryLanguages.push(this.localService.getSelectedLanguageId());
    this.mandatoryLanguages.push(this.languageManagementService.getEnglishLanguageId());
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right popup_overlay_medium',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.selectedTabKey = '1';
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.isShowLanguage = false;
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onReset() {
    this.isShowLanguage = false;
    setTimeout(() => {
      this.isShowLanguage = true;
    }, 100);
    this.productId = '';
    this.productInitializationWrapper.product.languageContents = null;
    this.productInitializationWrapper.product.languageCategory = null;
    this.productInitializationWrapper.product.languageAbout = null;
    this.productInitializationWrapper.product.languageNotes = null;
    this.productInitializationWrapper.product.content.v4 = '';
    this.productInitializationWrapper.product.content.key = '';
    this.productInitializationWrapper.product.content.v5 = '';
    this.productInitializationWrapper.product.content.v6 = '';
    this.productInitializationWrapper.product.content.v11 = '';
    this.productInitializationWrapper.product.content.v12 = '';
    this.productInitializationWrapper.product.content.v13 = '';
    this.productInitializationWrapper.product.printTemplateIds = [];
    this.productInitializationWrapper.product.customFields = this.onGetEmptyCustomFields();
    this.productInitializationWrapper.product.isAutoTransateAllowed = true;
    this.isSerialNumberAllowed = false;
    this.isGroupParentProductInReceipt = true;
    this.isTaxFree = false;
    this.isPrintTax = false;
    this.productInitializationWrapper.product.price.forEach(x => {
      x.content.v3 = null;
      x.content.v4 = null;
      x.taxFinal = [];
      x.requiredTax.forEach(y => {
        y.v3 = '';
      });
    });
    if (this.productInitializationWrapper.product.content != null) {
      this.productInitializationWrapper.product.content.v2 = "0";
    }
    this.localService.onFocusNextInput(this.elementIds.product_name + '_m', FocusInputType.TextBox, false, true);
  }

  onGetEmptyCustomFields(): KeyValues5[] {
    let items: KeyValues5[] = [];
    this.customFields.forEach(customField => {
      items.push({
        key: '-',
        v1: customField.key,
        v2: customField.v2,
        v3: customField.v3,
        v4: '',
      } as KeyValues5);
    });
    return items;
  }

  onSetTab() {
    if (this.localService.languageContent && this.localService.languageContent.product_config) {
      this.tabs = [
        { key: "1", value: this.localService.languageContent.common.all } as KeyValueSet,
        { key: "2", value: this.localService.languageContent.common.basics } as KeyValueSet,
        { key: "3", value: this.localService.languageContent.product_config.pricing_details } as KeyValueSet
      ];

      if (this.customFields && this.customFields.length > 0) {
        this.tabs.push({ key: "5", value: this.localService.languageContent.product_config.custom_fields } as KeyValueSet);
      }

      this.tabs.push({ key: "4", value: this.localService.languageContent.product_config.tab_product_notes } as KeyValueSet);
    }
  }

  onLoad() {
    this.isExcludePrice = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.IsExcludedPricingEnabled);

    this.message = '';
    this.isRedAlert = false;

    this.onSetTab();

    this.productManagementService.getProductInitialization(this.productId, this.businessId).subscribe(result => {
      this.productInitializationWrapper = result;
      if (this.productId == '') {
        this.productInitializationWrapper.product.content = {} as KeyValues15;
        this.onReset();
      } else {
        this.isShowLanguage = true;
        this.productInitializationWrapper.product.content.v1 = this.businessId;
        this.productInitializationWrapper.product.content.key = this.productId;
        this.isSerialNumberAllowed = this.productInitializationWrapper.product.content.v8 != "-1";
        this.isPrintTax = this.productInitializationWrapper.product.content.v10 == "1";
        this.productInitializationWrapper.product.isAutoTransateAllowed = true;
        this.isGroupParentProductInReceipt = this.productInitializationWrapper.product.content.v18 == "1";
        this.isTaxFree = this.productInitializationWrapper.product.content.v19 == "1";
      }
      this.localService.onFocusNextInput(this.elementIds.product_name + '_m', FocusInputType.TextBox, false, true);
    });

    setTimeout(() => {
      this.sideBarBodyHeight = window.outerHeight - 120;
    }, 100);
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.selectedTabKey = key;
      } break;
      case 2: {
        //Save product
        this.onSave();
      } break;
      case 3: {
        this.selectedLookupType = LookupType.HSN;
        this.selectedLookupValue = this.productInitializationWrapper.product.content.v11;
        const language = this.productInitializationWrapper.product.languageContents.find(x => x.v3 && x.v3.trim());
        this.searchKeyLookup = language ? language.v3 : '';
        this.isOpenLookup = true;
      } break;
      case 4: {
        this.selectedLookupType = LookupType.SAC;
        this.selectedLookupValue = this.productInitializationWrapper.product.content.v13;
        const language = this.productInitializationWrapper.product.languageContents.find(x => x.v3 && x.v3.trim());
        this.searchKeyLookup = language ? language.v3 : '';
        this.isOpenLookup = true;
      } break;
    }
  }

  onSelectLookup(key: string) {
    switch (this.selectedLookupType) {
      case LookupType.HSN: {
        this.productInitializationWrapper.product.content.v11 = key;
      } break;
      case LookupType.SAC: {
        this.productInitializationWrapper.product.content.v13 = key;
      } break;
    }
  }

  onEmptyLanguageContainerAdded(languageContents: any, index) {
    switch (index) {
      case 1: {
        this.productInitializationWrapper.product.languageContents = languageContents;
      } break;
      case 2: {
        this.productInitializationWrapper.product.languageCategory = languageContents;
      } break;
      case 3: {
        this.productInitializationWrapper.product.languageAbout = languageContents;
      } break;
      case 4: {
        this.productInitializationWrapper.product.languageNotes = languageContents;
      } break;
    }
  }

  onSave() {
    if (this.doCheck()) {
      this.productInitializationWrapper.product.content.v1 = this.businessId;
      this.productInitializationWrapper.product.content.v8 = this.isSerialNumberAllowed ? '1' : '0';
      this.productInitializationWrapper.product.content.v18 = this.isGroupParentProductInReceipt ? '1' : '0';
      this.productInitializationWrapper.product.content.v10 = this.isPrintTax ? '1' : '0';
      this.productInitializationWrapper.product.content.v19 = this.isTaxFree ? '1' : '0';
      this.productInitializationWrapper.product.content.v15 = this.selectedProductEntryType;
      this.productManagementService.saveProduct(this.productInitializationWrapper.product).subscribe(result => {
        switch (result.status) {
          case Status.Success: {
            if (this.productId == '') {
              this.isRedAlert = false;
              this.message = this.localService.languageContent.product_config.pin + ' : ' + result.id;
              this.onReset();
            } else {
              this.onCloseTrigger({ event: TriggeredEvent.Ok });
            }
          } break;
          default: {
            this.localService.showInformationByStatus(result.status, true);
          }
        }
      });
    }
  }

  doCheck() {
    this.isRedAlert = true;
    let message = '';
    if (!this.productInitializationWrapper.product.languageContents || this.productInitializationWrapper.product.languageContents.filter(x => x.v3.trim() != '').length == 0) {
      message = this.localService.languageContent.product_config.product_required;
      this.localService.onFocusNextInput(this.elementIds.product_name + '_m', FocusInputType.TextBox);
    } else if (this.productInitializationWrapper.product.content.v4 == null || this.productInitializationWrapper.product.content.v4 == '') {
      message = this.localService.languageContent.product_config.measurement_required;
      this.localService.onFocusNextInput(this.elementIds.measurement_type, FocusInputType.NgxDropDown);
    } else if (this.productInitializationWrapper.product.price.filter(x => (x.content.v4 == null || x.content.v4 == '') && (x.content.v4 != 0 || x.content.v4 != '0')).length > 0) {
      message = this.localService.languageContent.product_config.price_required;
      this.localService.onFocusNextInput(this.elementIds.txt_first_price, FocusInputType.TextBox);
    }
    this.message = message;
    return message == '';
  }
}
